export enum Page {
  Allocation = 'ALLOCATION',
  Driver = 'DRIVER',
  Mappings = 'MAPPINGS',
  Reports = 'REPORTS',
  SliceOrder = 'SliceOrder',
  ManageSliceAllocation = 'ManageSliceAllocation',
}
